export default __webpack_public_path__ + "static/media/delete.8f920623.svg";